import React from "react"
import { Badge, Table } from "react-bootstrap";

import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import StepButton from "../../../components/v2/StepButton";

const STEP_INFO = [
    {
        label: 'Step 1: Identify Focus Area',
        step: 2,
    },
    {
        label: 'Step 2: Design or Adapt the Assessment Tool',
        step: 3,
    },
    {
        label: 'Step 3: Conduct Assessment',
        step: 4,
    },
    {
        label: 'Step 4: Analyze the Collected Data - Round 1',
        step: 5,
    },
    {
        label: 'Step 5: Design and Plan Changes',
        step: 6,
    },
    {
        label: 'Step 6: Implemented Changes and Assess Again',
        step: 7,
    },
    {
        label: 'Step 7: Analyze the Collected Data - Round 2',
        step: 8,
    },
]

function calculateTotalCompleted(completedInfo, activePrograms) {
    let totalCompleted = 0
    if (completedInfo) {
        Object.keys(completedInfo).forEach((programId) => {
            if (programId in activePrograms && completedInfo[programId].completed) {
                totalCompleted = totalCompleted + 1
            }
        })
    }
    return totalCompleted
}

function ProgramStepTotal(props) {
    let step = props.step ? parseInt(props.step) - 1 : 0
    if (step === 1) {
        let totalCompleted = calculateTotalCompleted(props.step1CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    } else if (step === 2) {
        let totalCompleted = calculateTotalCompleted(props.step2CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    } else if (step === 3) {
        let totalCompleted = calculateTotalCompleted(props.step3CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    } else if (step === 4) {
        let totalCompleted = calculateTotalCompleted(props.step4CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    } else if (step === 5) {
        let totalCompleted = calculateTotalCompleted(props.step5CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    } else if (step === 6) {
        let totalCompleted = calculateTotalCompleted(props.step6CompletionData, props.activePrograms)
        if (totalCompleted > 0) {
            return <Badge bg="success" text="light">{totalCompleted} Completed</Badge>
        }
    }  else if (step === 7) {
        let totalCompleted = calculateTotalCompleted(props.step7CompletionData, props.activePrograms)
        let totalPart2Completed = calculateTotalCompleted(props.step7Tab2CompletionData, props.activePrograms)
        return <>
            {totalCompleted > 0 
                ? <Badge bg="success" text="light">{totalCompleted} Part 1</Badge>
                : ''
            }
            &nbsp;
            {totalPart2Completed > 0
                ? <Badge bg="success" text="light">{totalPart2Completed} Part 2</Badge>
                : ''
            }
            </>
    }
    return <></>
}

export default function AssessmentStep0(props) {
    return (
        <React.Fragment>
            <div className="text-center fs-2">
                Select Assessment Step to Work On
            </div>

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                        Use the ‘Go’ buttons below to start or continue work 
                        on a particular step of the assessment process, for the 
                        programs (degrees, certificates and gen ed areas) selected 
                        on the previous page.  These steps should be completed in 
                        sequential order.
                    </p>
                </div>

                <DepartmentHeader department={props.department} />

                <div>
                    <Table className="w-100">
                        <thead>
                            <tr>
                                <th>Step</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                STEP_INFO.map((item, index) =>
                                    <tr key={index}>
                                        <td>{item.label}</td>
                                        <td>
                                            <ProgramStepTotal
                                                step={item.step}
                                                activePrograms={props.activePrograms}
                                                step1CompletionData={props.step1CompletionData}
                                                step2CompletionData={props.step2CompletionData}
                                                step3CompletionData={props.step3CompletionData}
                                                step4CompletionData={props.step4CompletionData}
                                                step5CompletionData={props.step5CompletionData}
                                                step6CompletionData={props.step6CompletionData}
                                                step7CompletionData={props.step7CompletionData}
                                                step7Tab2CompletionData={props.step7Tab2CompletionData}
                                                />
                                        </td>
                                        <td>
                                            <StepButton 
                                                step={item.step} 
                                                setCurrentStep={props.setCurrentStep} 
                                                />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        </React.Fragment>
    )
}